import React, {useMemo} from 'react';
import {classes, style} from './doppe-layout-social-links.st.css';
import {DoppePageSocialLinks} from '../../../doppe-page-social-links/doppe-page-social-links';
import {BymoPageSocialLink, bymoPageSocialLinkIsHidden} from '../../../../client-server-common';

export const DoppeLayoutSocialLinks = React.memo(function DoppeLayoutSocialLinks(props: DoppeLayoutSocialLinks.Props) {
    const {
        className,

        socialLinks,
        ...htmlAttributes
    } = props;

    const visibleSocialLinks = useMemo(() => {
        return  socialLinks.filter(socialLink => !bymoPageSocialLinkIsHidden(socialLink));
    }, [socialLinks])

    return (
        visibleSocialLinks.length > 0 ? (
            <DoppePageSocialLinks
                {...htmlAttributes}
                className={style(classes.root, {}, className)}
                socialLinks={visibleSocialLinks}
            />
        ) : null
    )
});

export namespace DoppeLayoutSocialLinks {

    export interface Props extends React.HTMLAttributes<any> {
        socialLinks: BymoPageSocialLink[],
    }
}